import React, { useState, useContext } from 'react';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import UserDetailsContext from '../context/userDetails.context';
import { authenticate } from '../modules/auth';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Spinner from './Spinner.component';

import icon from '../images/icon.svg';


const Login = (props) => {
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { setUserDetails } = useContext(UserDetailsContext);

    // Form elements:
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [loginError, setLoginError] = useState(props.location.state && props.location.state.message ? props.location.state.message : '');
    const [validated, setValidated] = useState(false);



    function handleSubmit(event) {
        const form = event.currentTarget;
        setButtonDisabled(true);
        setLoginError('');
        setValidated(true);

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setButtonDisabled(false);
            return;
        }


        event.preventDefault();
        showLoading();
        authenticate(userName, password)
            .then(result => {
                const {
                    userId,
                    userName,
                    email,
                    userLocations,
                    token
                } = result;

                hideLoading();
                //setButtonDisabled(false);
                setUserDetails({ userId, userName, email, userLocations, token });
                //props.history.push('/'); // Redirect component redirects, because userDetails state has been updated, which causes a re-render.
                return;
            })
            .catch(error => {
                var msg;
                if (error && error.response && error.response.status) {
                    if (error.response.status === 401) {
                        // Set "Unknown username / password message
                        msg = "Unknown username or password.";
                    }
                }
                if (!msg)
                    msg = "Unable to login - please try again later.";
                setLoginError(msg);
                hideLoading();
                setButtonDisabled(false);
            });

    }

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <React.Fragment>
                    <Row style={{ justifyContent: 'center' }}>
                        <div className="login-card">
                            <div style={{ justifyContent: 'center', display: 'flex' }}>
                                <div className="brand_logo_container">
                                    <img src={icon} className="brand_logo" alt="Logo" />
                                </div>
                            </div>
                            <div className="form-container">
                                <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                                    <Form.Group controlId="formUsername">
                                        <span className="input-group-text"><FontAwesomeIcon icon="user" /></span>
                                        <Form.Control type="text" name="Username" placeholder="Username" value={userName} onChange={(e) => { setUserName(e.target.value); }} required />
                                        <div className="control-feedback">
                                            <Form.Control.Feedback type="invalid">
                                                Please fill in your username.
                                                </Form.Control.Feedback>
                                        </div>

                                    </Form.Group>

                                    <Form.Group controlId="formPassword">
                                        <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                                        <Form.Control type="password" name="Password" placeholder="Password" value={password} onChange={(e) => { setPassword(e.target.value); }} required />
                                        <div className="control-feedback">
                                            <Form.Control.Feedback type="invalid">
                                                Please fill in your password.
                                                </Form.Control.Feedback>
                                        </div>
                                    </Form.Group>

                                    <Form.Group>
                                        <Button className="login-button" disabled={buttonDisabled} type="submit">Log in <Spinner /></Button>
                                    </Form.Group>
                                    <Form.Label className="invalid-login">{loginError}</Form.Label>
                                </Form>
                                <div className="bottom-links" style={{ marginTop: "0.5em" }}>
                                    Don't have an account? <Link to="/register">Register</Link>
                                </div>
                                <div className="bottom-links">
                                    <Link to="/forgot-password">Forgot your password?</Link>
                                </div>
                            </div>
                        </div>
                    </Row>
                </React.Fragment>
            )}
        </ThemeContext.Consumer>
    );
};

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js